const findPlantId = () => {
  let id = window.location.hash;
  let rep1 = id.replace("/dashboard", "");
  let rep2 = rep1.split("/")[1];
  return rep2;
};

export default findPlantId;
